import React from 'react'
import { useViewport } from '../../../utils'
import { ButtonBookmarkIcon } from '../../../components'
import { useSelector } from 'react-redux'
import { excerptTrimmer } from '../../../utils/excerpt-trimmer'

const MAX_TITLE_LENGTH = 100
const THUMBNAIL_HEIGHT = '120px'
const THUMBNAIL_HEIGHT_MOBILE = '76px'

const Card = ({data, bookmark}) => {
  const {
    thumbnail,
    category,
    organization,
    title,
  } = data

  const { isMobile } = useViewport()
  const language = useSelector(state => state.system.language)

  const height = isMobile ? THUMBNAIL_HEIGHT_MOBILE : THUMBNAIL_HEIGHT
  const boxShadow = isMobile ? '0px 4px 10px rgba(0, 0, 0, 0.05)' : '0px 4px 20px rgba(0, 0, 0, 0.05)'

  const checkTranslation = (stringOrObject) => {
    const target = stringOrObject
    return typeof target === 'string' ? target
      : target && target[language.name] ? target[language.name]
      : JSON.stringify(target)
  }

  const titleRendered = excerptTrimmer(checkTranslation(title), MAX_TITLE_LENGTH)
  const categoryRendered = checkTranslation(category)

  return (
    <div
      className="bg-white rounded p-3 lg:p-5 h-full"
      style={{boxShadow: boxShadow}}
      title={checkTranslation(title)}
    >
      <div
        className="w-full bg-no-repeat bg-cover bg-center mb-4 rounded p-2"
        style={{backgroundImage: `url('${thumbnail}')`, height: height}}
      >
        {
          bookmark &&
          <ButtonBookmarkIcon className="ml-auto bg-white"/>
        }
      </div>
      <p className="text-gray-500 text-xs mb-2 leading-tight">
        <span className="debug-category">{categoryRendered}</span> /<br/>
        <span className="debug-organization">{organization}</span>
      </p>
      <h3 className="text-base lg:text-lg font-bold mb-2 font-primary leading-tight lg:leading-normal break-words">
        {titleRendered}
      </h3>
    </div>
  )
}

export { Card }
